export const faqData = [
  {
    id: 1,
    title: "What is NFT ?",
    text: "NFT stands for Non-Fungible token. By 'non-fungible' it implies that this token is unique and cannot be replaced or replicated",
  },
  {
    id: 2,
    title: "Are NFTs limited to digital art?",
    text: "No. NFTs are not limited to only digital items as the object itself is not the NFT but the underlying code. Anything from physical items to virtual assets can be sold as NFT.",
  },
  {
    id: 3,
    title: "How do I know if what I'm buying is legit and not a fake? ",
    text: "Each minted item has its own unique address and each item minted to a user's account is unique to its metadata.",
  },
  {
    id: 4,
    title: "How To Transfer My NFTs?",
    text: "NFTs can easily be transferred to other users on the blockchain. Simply click the menu icon and click on transfer.",
  },
  {
    id: 5,
    title: "How can I sell an NFT on Sportrex Marketplace?",
    text: "To sell NFT assets on the Sportrex marketplace, users have to first click the create button to create their NFT, then mint and list it on our marketplace.",
  },
  {
    id: 6,
    title: "How much does it cost to create an NFT?",
    text: "There is a minting fee (Gas Fee) which users have to pay the Gas fees to transact on the platform.",
  },
  {
    id: 7,
    title: "Do I need a wallet and how do I create one? ",
    text: "Yes, you need a wallet to hold your cryptocurrency and NFT assets. You can easily create a wallet by downloading Sportrex wallet. Other popular wallets you can use are Metamask, Coinbase, etc.",
  },
  {
    id: 8,
    title: "How do I buy NFT on Sportrex?",
    text: "You can easily buy NFT from the Sportrex marketplace (sportrex.io/marketplace) by clicking on the item you want, this will bring up the product page where you can make a purchase or bid on the item. Once the transaction is confirmed by the blockchain, you can find your NFT in your profile (link to profile) and wallet.",
  },
  {
    id: 9,
    title: "How do I view products in AR/VR Mode?",
    text: "You can view products in VR/AR mode when you are using a compatible device. All you have to do is click the view in AR/VR Mode on the product image.",
  },
  {
    id: 10,
    title: "Which Blochains does Sportrex support?",
    text: "Sportrex is a decentralized web3 platform which gives users the freedom and liberty to mint using the technology of their choice. Web3 is limitless and so is Sportrex. Cheers.",
  },
  {
    id: 11,
    title: "Is Sportrex secured with wallet integration?",
    text: "YES, sportrex did not have access to your crypto wallet without your confirmation, you only give permission to view the addresses of your permitted accounts which means we do not have access to remove anything from your crypocurrency assets.",
  },
  {
    id: 12,
    title: "What is NFT staking?",
    text: "NFT staking is locking your NFT asset in Sportrex’s vault in exchange for a staking reward and other benefits. Also, you can earn #SPT Token when you stake your NFT assets.",
  },
  {
    id: 13,
    title: "I want to learn more about Sportrex and NFT.",
    text: "You can learn more by joining our social media communities on twitter, facebook, Telegram, Instagram, Discord. Or go to our blog.",
  },
  {
    id: 14,
    title: "Where are your Privacy policy and term of use?",
    text: "Privacy policy and Term of use can be found on the website header under the resource navigation bar.",
  },
]; 